import Button from '@mui/material/Button';

import { useLocales } from 'src/locales';
import { RouterLink } from 'src/routes/components';
import { EmptyContent } from 'src/components/empty-content';

// ----------------------------------------------------------------------

type Props = {
  backHref: string;
  backLabel: string;
};

/**
 * Shown by an admin view whose record could not be loaded. An edit view that rendered its form
 * anyway would open it in create mode, and saving would add a duplicate record instead of
 * editing this one. Callers key on the record being absent, not on the request's `error`: SWR
 * keeps the last good data through a failed revalidation, and a loaded record keeps its form.
 */
export function RecordUnavailable({ backHref, backLabel }: Props) {
  const { t } = useLocales('common');

  return (
    <EmptyContent
      filled
      title={t('record_unavailable')}
      description={t('record_unavailable_failed')}
      action={
        <Button component={RouterLink} href={backHref} variant="outlined" sx={{ mt: 3 }}>
          {backLabel}
        </Button>
      }
      sx={{ py: 10 }}
    />
  );
}
